module.exports = __webpack_public_path__ + "img/Locke-03.83227c63.png";